<template lang="html">
  <div class="inv-container">
    <p class="title">发票申请</p>
    <p class="info">1.当前发票默认开具普通电子发票（具有同等法律效力，可支持报销入账），如需其它发票请填写备注。</p>
    <p class="info">2.请务必确保填写准确真实的信息。</p>
    <p class="info">3.带<span>*</span>的为必填项。</p>
    <p class="title">发票信息填写 <span>您当前申请发票金额</span><span>￥</span><span>{{form_data.total}}</span></p>
    <Form ref="form" :model="form_data" :rules="rules">
      <FormItem class="form-group" prop="invoice_title">
        <label class="req">发票抬头</label><Input v-model="form_data.invoice_title" type="text" name="invoice_title" autocomplete="off" placeholder="请输入发票抬头"></Input>
      </FormItem>
      <FormItem class="form-group" prop="nsr_code">
        <label class="req">纳税人识别号</label><Input v-model="form_data.nsr_code" type="text" name="nsr_code" autocomplete="off" placeholder="请输入纳税人识别号"></Input>
      </FormItem>
      <FormItem class="form-group" prop="contact">
        <label class="req">发票收件人</label><Input v-model="form_data.contact" type="text" name="contact" autocomplete="off" placeholder="请输入发票收件人姓名"></Input>
      </FormItem>
      <FormItem class="form-group" prop="tel">
        <label class="req">联系方式</label><Input v-model="form_data.tel" type="text" name="tel" autocomplete="off" placeholder="请输入收件人联系方式"></Input>
      </FormItem>
      <FormItem class="form-group" prop="email">
        <label class="req">邮箱</label><Input v-model="form_data.email" type="text" name="email" autocomplete="off" placeholder="请输入收件人邮箱"></Input>
      </FormItem>
      <FormItem class="form-group" prop="address">
        <label class="req">寄送地址</label><Input v-model="form_data.address" type="text" name="address" autocomplete="off" placeholder="请输入电子发票寄送地址"></Input>
      </FormItem>
      <FormItem class="form-group">
        <label style="vertical-align:top">备注说明</label><textarea v-model="comment" type="text" name="comment" autocomplete="off" rows="5" placeholder="如需其它发票请填写备注"></textarea>
      </FormItem>
      <FormItem class="form-group">
        <label></label>
        <div class="button-group">
          <Button size="small" type="primary" @click="submit">提交申请</Button>
          <Button size="small" type="primary" @click="goList">取消</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { addInvoice, invoiceTitle } from "../../service"
export default {
  data() {
    return {
      form_data: {
        invoice_title: '',
        nsr_code: '',
        contact: '',
        tel: '',
        email: '',
        address: '',
        total: this.$route.query.price
      },
      comment: '',
      rules: {
        invoice_title:[{required: true, message:'请输入发票抬头', trigger: 'blur'}],
        nsr_code:[{required: true, message:'请输入纳税人识别号', trigger: 'blur'}],
        contact:[{required: true, message:'请输入发票收件人', trigger: 'blur'}],
        tel:[
          {required: true, message:'请输入联系方式', trigger: 'blur'},
          { type: 'number', message: '手机号格式不正确', trigger: 'blur', transform(value) {
            let reg = /^1[3456789]\d{9}$/
            if (!reg.test(value)) {
              return false
            } else {
              return Number(value)
            }
          }}
        ],
        email:[
          {required: true, message:'请输入邮箱', trigger: 'blur'},
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        address:[{required: true, message:'请输入发票寄送地址', trigger: 'blur'}]
      }
    }
  },
  computed: {
    order_uid_arr() {
      return this.$store.state.order_uid_arr
    }
  },
  methods: {
    submit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let res = await addInvoice({
            user_key: this.$store.state.user_key,
            payment_uid_arr: this.order_uid_arr,
            col: this.form_data,
            comment: this.comment
          }, (error) => {this.$Message.error('提交失败')})
          if (res.status == 'success') {
            this.$Message.success('提交成功！')
            this.$router.replace({name: 'OrderList'})
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    async getInvoiceTitle() {
      let res = await invoiceTitle({user_key: this.$store.state.user_key}, (error) => {this.$Message.error('请求错误')})
      if (res.status == 'success') {
        if (res.res.length != 0) {
          this.form_data.invoice_title = res.res[0].invoice_title
          this.form_data.address = res.res[0].address
          this.form_data.tel = res.res[0].tel
          this.form_data.contact = res.res[0].contact
          this.form_data.nsr_code = res.res[0].nsr_code
          this.form_data.email = res.res[0].email
        }
      }
    },
    goList() { // 回到发票列表
      this.$router.replace({name: 'OrderList'})
    }
  },
  created() {
    this.getInvoiceTitle()
  },
  destroyed() {
    this.$store.commit('updateOrderArr',[])
  }
}
</script>
<style lang="stylus" scoped>
.inv-container
  width: 1200px;
  margin: 0 auto;
  .title
    margin-top: 30px;
    padding-bottom: 12px;
    border-bottom: 1px solid;
    commonBorderColor(#2D313A,#E9E9E9)
    font-size:18px;
    commonColor(#FFFFFF, #333333);
    vertical-align: text-bottom;
    span:nth-child(1)
      margin-left: 24px;
      font-size: 14px;
      color: #999999;
    span:nth-child(2)
      margin-left: 10px;
      font-size: 14px;
      color: rgba(250, 122, 80, 1);
      font-weight: bold;
    span:nth-child(3)
      font-size: 26px;
      color: rgba(250, 122, 80, 1);
      font-weight: bold;
  .info
    margin-top: 28px;
    font-size:14px;
    font-weight: 500;
    commonColor(#FFFFFF, #333333);
    span
      color: #FC3B3B;
    &+.info
      margin-top: 10px;
  form
    padding-top: 30px;
  .form-group
    margin-bottom: 16px;
    label
      display: inline-block;
      font-size:14px;
      width: 100px;
      text-align: right;
      margin-right: 15px;
      commonColor(#FFFFFF, #666666);
      &.req:before
        content: '*';
        color:#FC3B3B;
        font-size: 14px;
    >>> .ivu-input-wrapper
      width: auto;
    >>> input,textarea
      commonBgColor(#181A23, #FFFFFF);
      border:1px solid;
      commonBorderColor(#999999, #DADCE2)
      border-radius:4px;
      width:360px;
      font-size:14px;
      font-weight:500;
      commonColor(#FFFFFF, #333333);
      padding: 8px 12px;
      &::placeholder
        color: #999;
      &:focus
        border:1px solid rgba(250, 122, 80, 1);
        box-shadow: none;
    >>> .ivu-form-item-error-tip
      top: 90%;
      left: 120px;
    .button-group
      display: inline-block;
      button:nth-child(1)
        border:1px solid rgba(250, 122, 80, 1);
        background-color: rgba(250, 122, 80, 1);
      button:nth-child(2)
        border:1px solid rgba(250, 122, 80, 1);
        commonBgColor(#181A23, #ffffff);
        color: rgba(250, 122, 80, 1);
      button
        padding: 6px 0;
        width: 96px;
      button+button
        margin-left: 20px;
</style>
